import cn from 'classnames';
import { useEffect, useState } from 'react';

import { usePdfHelpers } from 'src/hooks/usePdfHelpers';

import { setJumpLinkAttributes } from 'src/utils/jumpLinks';

import ArticleGrid from 'components/BaseHelpers/ArticleGrid/ArticleGrid';
import Cta from 'components/BaseHelpers/Cta';
import RichText from 'components/BaseHelpers/RichText';
import StartIndex from 'components/BaseHelpers/StartIndex';
import StopIndex from 'components/BaseHelpers/StopIndex';
import Text from 'components/BaseHelpers/Text';

import { ComponentProps } from '../../../types/component-props';
import { CoreRelatedNewsInsightsGridData } from '../../../types/components';

import styles from './CoreRelatedNewsInsightsGrid.module.scss';

export type CoreRelatedNewsInsightsGridProps = ComponentProps & CoreRelatedNewsInsightsGridData;

const CoreRelatedNewsInsightsGrid = (props: CoreRelatedNewsInsightsGridProps): JSX.Element => {
  const { heading, description, items, displayCount, showAllLabel, jumpLinkLabel } = props.fields;
  const { isPdf } = usePdfHelpers();
  const [currentDisplayCount, setCurrentDisplayCount] = useState(displayCount);

  useEffect(() => {
    setCurrentDisplayCount(displayCount);
  }, [items, displayCount]);

  const handleLoadMore = () => {
    setCurrentDisplayCount((count) => count + displayCount);
  };

  if (items.length === 0) {
    return <></>;
  }

  const itemsToDisplay = isPdf ? items : items.slice(0, currentDisplayCount);

  return (
    <>
      <StopIndex />
      <div className={cn(styles.main, 'container-10')} {...setJumpLinkAttributes(jumpLinkLabel)}>
        <Text tag="h2" className={cn('heading-h3', styles.heading)} field={heading} />
        <RichText className="body-med" field={description} />
        <ArticleGrid items={itemsToDisplay} className={styles.grid} />
        {itemsToDisplay.length < items.length && (
          <Cta tag="button" onClick={handleLoadMore} className={styles.cta}>
            {showAllLabel}
          </Cta>
        )}
      </div>
      <StartIndex />
    </>
  );
};

export default CoreRelatedNewsInsightsGrid;
